<script setup lang="ts">
import { bemBuilder } from "@chatfood/core-utils";
import { computed } from "vue";
import { AtomText } from "@chatfood/design-system";
import { LoyaltyProgramHandler } from "../loyalty-program-handler";
import { LoyaltyRedeemCash } from "../loyalty-redeem-cash";
import { DiscountView } from "../discount-view";
import { GiftCardView } from "../gift-card-view";
import { useCustomerStore } from "~/stores/customer";
import { useLoyaltyProgramStore } from "~/stores/loyaltyProgram";
import { useLocale } from "~/composables/use-locale";

const css = bemBuilder("basket-claims");
const { t } = useLocale();

const customerStore = useCustomerStore();
const loyaltyProgramStore = useLoyaltyProgramStore();

const shouldDisplayLoyaltyFeature = computed(() => {
  return loyaltyProgramStore.isEnabled && customerStore.isLogged;
});

const displayLoyaltyProgramHandler = computed(() => {
  return (
    shouldDisplayLoyaltyFeature.value && loyaltyProgramStore.canRedeemPoints
  );
});

const displayLoyaltyRedeemCash = computed(() => {
  return (
    shouldDisplayLoyaltyFeature.value &&
    loyaltyProgramStore.canRedeemCash &&
    loyaltyProgramStore.service === "deliverect" &&
    customerStore.loyalty.wallet.cash.balance.value > 0
  );
});
</script>

<template>
  <div :class="css('')">
    <AtomText type="subtitle">
      {{ t("components.basket_claims.title_offers") }}
    </AtomText>
    <LoyaltyProgramHandler v-if="displayLoyaltyProgramHandler" />
    <LoyaltyRedeemCash v-if="displayLoyaltyRedeemCash" />
    <DiscountView />
    <GiftCardView />
  </div>
</template>

<style lang="scss" scoped>
.basket-claims {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}
</style>
